import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";

/** Newest app releases, straight from the changelog. Staff-facing. */
export function ReleaseNotesCard({ limit = 4 }) {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/changelog", { params: { limit: 40 } })
      .then((r) => setItems((r.data.items || []).slice(0, limit)))
      .catch(() => {});
  }, [limit]);

  if (!items.length) return null;

  return (
    <Card className="border-slate-200 shadow-sm" data-testid="card-release-notes">
      <div className="flex items-center gap-2 border-b border-slate-100 px-5 py-3">
        <Sparkles className="h-4 w-4 text-primary" />
        <h3 className="font-heading text-sm font-semibold text-slate-800">What&apos;s new</h3>
        <button onClick={() => navigate("/changelog")} data-testid="release-notes-view-all"
          className="ml-auto text-[11px] font-semibold text-primary hover:underline">
          View all
        </button>
      </div>
      <div className="divide-y divide-slate-100">
        {items.map((e) => {
          const lines = (e.notes || "").split("\n").filter((l) => l.trim().startsWith("•")).slice(0, 3);
          return (
            <button key={e.entry_id} onClick={() => navigate("/changelog")}
              data-testid={`release-note-${e.entry_id}`}
              className="block w-full px-5 py-3 text-left transition-colors hover:bg-slate-50">
              <div className="flex items-baseline gap-2">
                <span className="text-sm font-semibold text-slate-800">{e.app_name}</span>
                <span className="rounded bg-slate-100 px-1.5 font-mono text-[10px] text-slate-600">v{e.version}</span>
                <time className="ml-auto text-[11px] text-slate-400">
                  {new Date(e.released_at).toLocaleDateString(undefined, { month: "short", day: "numeric" })}
                </time>
              </div>
              <ul className="mt-1 space-y-0.5">
                {lines.map((l, i) => (
                  <li key={i} className="truncate text-xs text-slate-500">{l.replace(/^•\s*/, "· ")}</li>
                ))}
              </ul>
            </button>
          );
        })}
      </div>
    </Card>
  );
}
